import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const ActionsIcon: TIconType = (props?: IIconProps) => {
	const { color = colors.indigo70 } = props?.innerSvgProps || {};
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
			{...props?.innerSvgProps}
		>
			<circle
				cx='10'
				cy='15'
				fill={color || 'currentColor'}

				r='1.25'
			/>
			<circle
				cx='10'
				cy='10'
				fill={color || 'currentColor'}
				r='1.25'
			/>
			<circle
				cx='10'
				cy='5'
				fill={color || 'currentColor'}
				r='1.25'
			/>
		</svg>
	);
};

export default ActionsIcon;
